module.exports = __webpack_public_path__ + "static/media/Jobvious_white_logo_base.a5f7640a.svg";